import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Payment\DeletePaymentController::undo
* @see app/Http/Controllers/Payment/DeletePaymentController.php
* @route '/api/invoicing/{invoice}/payment/{id}/undo-delete'
*/
export const undo = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/payment/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Payment\DeletePaymentController::undo
* @see app/Http/Controllers/Payment/DeletePaymentController.php
* @route '/api/invoicing/{invoice}/payment/{id}/undo-delete'
*/
undo.url = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        id: args.id,
    }

    return undo.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Payment\DeletePaymentController::undo
* @see app/Http/Controllers/Payment/DeletePaymentController.php
* @route '/api/invoicing/{invoice}/payment/{id}/undo-delete'
*/
undo.get = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Payment\DeletePaymentController::undo
* @see app/Http/Controllers/Payment/DeletePaymentController.php
* @route '/api/invoicing/{invoice}/payment/{id}/undo-delete'
*/
undo.head = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Payment\DeletePaymentController::deleteMethod
* @see app/Http/Controllers/Payment/DeletePaymentController.php
* @route '/api/invoicing/{invoice}/payment/{payment}'
*/
export const deleteMethod = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/invoicing/{invoice}/payment/{payment}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Payment\DeletePaymentController::deleteMethod
* @see app/Http/Controllers/Payment/DeletePaymentController.php
* @route '/api/invoicing/{invoice}/payment/{payment}'
*/
deleteMethod.url = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        payment: typeof args.payment === 'object'
        ? args.payment.id
        : args.payment,
    }

    return deleteMethod.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Payment\DeletePaymentController::deleteMethod
* @see app/Http/Controllers/Payment/DeletePaymentController.php
* @route '/api/invoicing/{invoice}/payment/{payment}'
*/
deleteMethod.delete = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

const DeletePaymentController = { undo, deleteMethod, delete: deleteMethod }

export default DeletePaymentController